import React, { useState, useRef } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";

const UpdateIndexPhotos = () => {
  const { access } = useIsAdmin();
  document.title = "LVF1 - Update Index Photos";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const refMainLight = useRef<any>(null);
  const refMainDark = useRef<any>(null);
  const refSecLight = useRef<any>(null);
  const refSecDark = useRef<any>(null);
  const [pictureMainLight, setPictureMainLight] = useState();
  const [pictureMainDark, setPictureMainDark] = useState();
  const [pictureSecLight, setPictureSecLight] = useState();
  const [pictureSecDark, setPictureSecDark] = useState();
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);

  const submitForm = (event: any) => {
    if (token == null) return;
    /* REALOADS BECAUSE THE FOLDER OF THE PDFS IS INSIDE /PUBLIC ! */
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);

    if (pictureMainLight != null)
      formDataFiles.append("pictureMainLight", pictureMainLight);
    if (pictureMainDark != null)
      formDataFiles.append("pictureMainDark", pictureMainDark);
    if (pictureSecLight != null)
      formDataFiles.append("pictureSecLight", pictureSecLight);
    if (pictureSecDark != null)
      formDataFiles.append("pictureSecDark", pictureSecDark);

    if (!(form !== null && form.checkValidity() === false)) {
      setUploading(true);
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/updateIndexPhotos`,
          formDataFiles
        )
        .then(() => {
          toast.success("Photos updated successfully");
          setUploading(false);
          setValidated(false);
        })
        .catch(({ response }) => {
          toast.error("Error updating photos");
          setUploading(false);
          setValidated(false);
          throw new Error(response);
        });
    }
    setValidated(true);
  };

  if (!access) return <ErrorPage />;
  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Update Photos" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form noValidate validated={validated} onSubmit={submitForm}>
          <h4>Main Championship</h4>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Light Photo</Form.Label>
              <Form.Control
                type="file"
                ref={refMainLight}
                accept=".jpg"
                onChange={() =>
                  setPictureMainLight(refMainLight.current.files[0])
                }
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Dark Photo</Form.Label>
              <Form.Control
                type="file"
                ref={refMainDark}
                accept=".jpg"
                onChange={() =>
                  setPictureMainDark(refMainDark.current.files[0])
                }
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <h4>Secondary Championship</h4>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Light Photo</Form.Label>
              <Form.Control
                type="file"
                ref={refSecLight}
                accept=".jpg"
                onChange={() =>
                  setPictureSecLight(refSecLight.current.files[0])
                }
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Dark Photo</Form.Label>
              <Form.Control
                type="file"
                ref={refSecDark}
                accept=".jpg"
                onChange={() => setPictureSecDark(refSecDark.current.files[0])}
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-center">
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button variant="primary" type="submit">
                Update Photos
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default UpdateIndexPhotos;
